import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import OrdersLayout from "../sidenavs/orders/ordersnavlayout";
import LabsTab from "./tabs/labs";
import NavButtons from "./nav/navbuttons";
import Proceduretab from "./tabs/procedure";
import Injectionstab from "./tabs/injections";
import Refillstab from "./tabs/refills";
import ScheduleTab from "./tabs/scheduledRto";
import ReferalsTab from "./tabs/referals";
import MedicalRecordsTab from "./tabs/medicalrecords";
import api from "../api/api";
import { useDispatch, useSelector } from "react-redux";
import { setAppointmentInfo } from "../reduxtoolkit/orders/appinfo";
import {
  Backdrop,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  Slider,
} from "@mui/material";
import {
  updatelov2Value,
  updatelovValue,
  updateTov2Value,
  updateTovValue,
} from "../reduxtoolkit/dump";
import columnicon from "../../src/assets/orders/rename.svg";
import scheduleicon from "../../src/assets/orders/schedule.svg";
import referalicon from "../../src/assets/orders/referals.svg";
import refillicon from "../../src/assets/orders/refills.svg";
import medicalrecord from "../../src/assets/orders/records.svg";
import procedureicon from "../../src/assets/orders/procedures.svg";
import injectionicon from "../../src/assets/orders/Injections.svg";
import VitaminsIcon from "../../src/assets/orders/VitaminsIcon.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faTimes } from "@fortawesome/free-solid-svg-icons";
import { setSearchResults } from "../../src/reduxtoolkit/orders/universalsearch";
import CloseIcon from "@mui/icons-material/Close";
import { crossIcon, saveIcon } from "./tabs/svg";
import ToastMessage from "../utils/mui/righttoptoast";
import VitaminTab from "./tabs/vitamin";
import { eventBus } from "../utils/eventBus";
import dayjs from "dayjs";
import { setOrdersData } from "../reduxtoolkit/orders/ordersdataSlice";
import UnsavedChangesModal from "../utils/modals/unsavedchanges";
import { setOrders } from "../reduxtoolkit/orders/ordersSlice";
const Orders = ({ appointmentId, setShowOrders, showOrders='',ordersref='',setOrdersref=(()=>{}),startDate,  }) => {
  
  // const { id, dt,filter } = useParams(); // Extract `appointmentid` from the route
  const { id, dt: paramDt, filter } = useParams();
const dt = paramDt || startDate;

  const [tab, setTab] = useState(0);
  const [alertmessage, setAlertMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true); // Track loading state
  const [appointmentData, setAppointmentData] = useState(null); // Store fetched data
  const [universalSearch, setUniversalSearch] = useState("");
  const [getordersData, setGetOrdersData] = useState([]);
  const [selectedSuggestionList, setSelectedSuggestionList] = useState([]);
  const [referals, setReferals] = useState([]);
  const [selectedCard, SetSelectedCard] = useState("f");
  const practiseid = window.getPracticeId();
  const navigate = useNavigate();
  const [suggestionData,setSuggestionsData]=useState([])
  const [loading, setLoading] = useState(false);
  const[searchcard,setSearchCard]=useState('')
  const [isfilled,setIsfilled]=useState(false)
  const[firstOrders,setFirstOrders]=useState([])
  const[latestorders,setLatestOrders]=useState([])
  const[showUnsavedModal,setShowUnsavedModal]=useState(false)
  const location = useLocation();
  const isOrdersRoute = location.pathname.startsWith("/orders");


  const lovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "lov")?.value
  );
  const userConfig = useSelector((state) => state.userconfig);
  const tovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "tov")?.value
  );
  const lov2Value = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "lov2")?.value
  );
  const tov2Value = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "tov2")?.value
  );
  const dispatch = useDispatch();
  let data = appointmentData;

  const debounceTimeoutRef = useRef(null);

  const handleChange = (newValue) => {
    const numericValue = Number(newValue); // Convert the value to a number
    dispatch(updatelovValue(numericValue)); // Dispatch the action with the numeric value
  };

  const handletabs = (e) => {
    if (e == 8) return;
    setTab(e);
  };
  const handlealert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
const SaveIconwithprop = ({ size = 17 }) => {
  return (
    <svg
      width={size}
      height={size - 1}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="stroke-current"   // IMPORTANT
    >
      <path
        d="M13.6849 4L6.35152 11.3333L3.01819 8"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};


  const navItems = [
    {
      label: "Labs",
      id: 0,
      icon: <img src={columnicon} alt="" />,
      onClick: handletabs,
    },
    {
      label: "Procedures",
      id: 1,
      icon: <img src={procedureicon} alt="" />,
      onClick: handletabs,
    },
    {
      label: "Injections",
      id: 2,
      icon: <img src={injectionicon} alt="" />,
      onClick: handletabs,
    },
    {
      label: "Refills",
      id: 3,
      icon: <img style={{ width: "13px" }} src={refillicon} alt="" />,
      onClick: handletabs,
    },
    {
      label: "Schedule",
      id: 4,
      icon: <img src={scheduleicon} alt="" />,
      onClick: handletabs,
    },
    {
      label: "Referrals",
      id: 5,
      icon: <img src={referalicon} alt="" />,
      onClick: handletabs,
    },
    {
      label: "Records",
      id: 6,
      icon: <img src={medicalrecord} alt="" />,
      onClick: handletabs,
    },
    {
      label: "Vitamins",
      id: 7,
      icon: <img src={VitaminsIcon} alt="" />,
      onClick: handletabs,
    },
  ];

  const fetchData = async () => {
    setIsLoading(true); // Start loading
    try {
      const response = await api.post(`/v1/${practiseid}/appointments/info`, {
        appointmentid: id || appointmentId, // Use `appointmentid` from the route
      });

      if (response.status === 200) {
        setAppointmentData(response.data && response.data[0]);
        dispatch(setAppointmentInfo(response.data && response.data[0]));
                    const requestPayload = {
     appointmentdate:dayjs(dt).isValid()
  ? dayjs(dt).format("YYYY-MM-DD")
  : dayjs().format("YYYY-MM-DD")
,

      searchflag:  response.data[0].patientid || null,
      dashfilter: null, // Use tabFilter if provided, otherwise fall back to Redux tab
      filterarr: [],
      start: 0,
      limit: 0,
    }
        const searchresp = await api.post(
        `/v1/${practiseid}/appointments/dashboard`,
        requestPayload
      )
      if(response.status==200){
        setSearchCard(searchresp?.data[0])
      }else{
        setSearchCard('')
      }
      }
      // Store the response data
    } catch (error) {
      console.error("Error fetching appointment data:", error);
    } finally {
      setIsLoading(false); // End loading
    }
  };

  useEffect(() => {
    if (id || appointmentId) {
      fetchData();
    }
  }, [id, appointmentId]);

  const handleuniversalSearch = (e) => {
    const value = e.target.value;
    setUniversalSearch(value);

    // Clear the previous timeout
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }
    if (value.trim() === "") {
      dispatch(setSearchResults([]));
      return;
    }
    // Set a new timeout
    debounceTimeoutRef.current = setTimeout(async () => {
      try {
    
        const response = await api.post(
          `/v1/${practiseid}/patientid/${appointmentData?.patientid}/orders/universalsearch`,
          {
            item: value,
            st_date: dt && dt.includes(' ') && !isNaN(Date.parse(dt.split(' ')[0])) 
         ? dt.split(' ')[0] 
         : new Date().toISOString().split('T')[0],
          }
        );

        if (response.status === 200) {
          dispatch(setSearchResults(response.data));
        } else {
          dispatch(setSearchResults([]));
        }
      } catch (error) {
        console.error("Error during universal search:", error);
      }
    }, 500); // Adjust debounce delay (e.g., 500ms) as needed
  };
  
  const getorders = async (x) => {
    try {
      const selectedsuggestions = await api.post(
        `/v1/${practiseid}/orders/patient/${data.patientid}/get-orders`,
        {
          appointmentid: data.appointmentid,
          // "orderdate": data.created_at ? new Date(data.created_at).toISOString().split('T')[0] : "Invalid date"
          orderdate:dayjs(dt).isValid()
  ? dayjs(dt).format("YYYY-MM-DD")
  : dayjs().format("YYYY-MM-DD"),
        }
      );
      if (selectedsuggestions.status === 200) {
        console.log(isfilled,'isfiled')
if(!isfilled){
  setFirstOrders(selectedsuggestions?.data?.look||[])
    setLatestOrders(selectedsuggestions?.data?.look||[])
console.log(selectedsuggestions?.data?.look,'firstorders')
   setIsfilled(true)
}else{
  console.log(selectedsuggestions?.data?.look,'selec')
  setLatestOrders(selectedsuggestions?.data?.look||[])
}
       

        const lovtovItem = selectedsuggestions?.data?.lovtov?.[0];
        if (!x) {
          if (lovtovItem) {
            dispatch(updatelovValue(lovtovItem.lov));
            dispatch(updateTovValue(lovtovItem.tov));
            dispatch(updatelov2Value(lovtovItem.lov2));
            dispatch(updateTov2Value(lovtovItem.tov2));
          } else {
            // Optional: set defaults if needed
            dispatch(updatelovValue(null));
            dispatch(updateTovValue(null));
            dispatch(updatelov2Value(null));
            dispatch(updateTov2Value(null));
          }
        }

        const suggestionList = selectedsuggestions.data?.look || [];
        setGetOrdersData(selectedsuggestions?.data);
        setSelectedSuggestionList(suggestionList);
        setReferals(selectedsuggestions.data?.referrals || []);
        return selectedsuggestions?.data;
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(()=>{
console.log(latestorders,'latte')
  },[latestorders])
  const fetchsuggestions=async()=>{
      // "appointmentid": 574518,
  try {
      setLoading(true)
      const response =await api.post(`/v1/${practiseid}/orders/get/suggestions`,{
          "patientid": data.patientid,
          "category": tab==0?"labs":tab==1?"procedure":tab==2?"injection":tab==4?"schedule":tab==5?"referral":tab==6?"mrecord":tab==7?"vitamin":"all",
          "searchflag":"",
          // "searchdate": data.created_at?new Date(data.created_at).toISOString().split('T')[0]: "Invalid date"
         "searchdate": dt && dt.includes(' ') && !isNaN(Date.parse(dt.split(' ')[0])) 
         ? dt.split(' ')[0] 
         : new Date().toISOString().split('T')[0]
      })
  getorders()
      if(response.status===200){
        setSuggestionsData(response.data)
      }else{
          setSuggestionsData([])
      }
  } catch (error) {
      
  }finally{
  setLoading(false)
  
  }
  }
  const handleClose = async () => {
    try {
      const getorder = await getorders();
      setLoading(true);
      const response = await api.delete(
        `/v1/${practiseid}/orders/delete/patient/${data.patientid}/notconfirmed`,
        {
          data: {
            // orderdate: data.created_at?new Date(data.created_at).toISOString().split('T')[0]: "Invalid date",
            orderdate:dayjs(dt).isValid()
  ? dayjs(dt).format("YYYY-MM-DD")
  : dayjs().format("YYYY-MM-DD"),
          },
        }
      );
      setTimeout(() => {
        if (appointmentId) {
          //
           eventBus.emit("fetchSummary")
          setShowOrders(false);
        } else {
     if( filter!=='all'){
      navigate('/landing', {
    state: { fromPatientId: data.patientid }
  })
            }else{
           navigate('/landing')   
            }
        }
      }, 2000);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);

    fetchsuggestions()
    setOrdersref(false)
    }
  };

  const handleSave = async (block) => {
    setLoading(true);
console.log(tovValue,'fromuseeeffect')



    try {
      console.log(tovValue,'tovvvv')
      const getorder = await getorders("block");
      console.log(getorder);

      const ordersicd = getorder.diagnosis || []; // Make sure it's an array

      const icd10Array = ordersicd.map((item) => item.icd10);

      if (!lovValue&&!block) {
        setAlertMessage("Level of visit is not selected");
        setSeverity("info");
        setOpen(true);
      }
      if (!tovValue&&!block) {
        setAlertMessage("Type of visit is not selected");
        setSeverity("info");
        setOpen(true);
      }
      const payload = {
        patientid: data.patientid,
        orderdate:
          dt && dt.includes(" ") && !isNaN(Date.parse(dt.split(" ")[0]))
            ? dt.split(" ")[0]
            : new Date().toISOString().split("T")[0],
      };

      const getordersss = await api.post(
        `/v1/${practiseid}/orders/get`,
        payload
      );

      let hasVisitOrder;
      if (getordersss.status === 200) {
        hasVisitOrder = getordersss?.data.some(
          (order) => order.ordertype === "VISIT"
        );
      } else {
        hasVisitOrder = false;
      }
      
      if (tovValue && hasVisitOrder) {
        if (
          tovValue === getorder?.lovtov[0]?.tov &&
          lovValue === getorder?.lovtov[0]?.lov
        ) {
        } else {
          await api.put(
            `/v1/${practiseid}/patient/${data.patientid}/orders/lovtov/update`,
            {
              patientname: `${data.firstname || ""} ${
                data.lastname || ""
              }`.trim(),
              orderdate:
                dt && dt.includes(" ") && !isNaN(Date.parse(dt.split(" ")[0]))
                  ? dt.split(" ")[0]
                  : new Date().toISOString().split("T")[0],
              lov: lovValue||'',
              ordlist: tovValue,
              task: "VISIT",
              loginuser: userConfig?.username,
              user_role: "ALL",
            }
          );
        }
      } else if(tovValue) {
     
        const createResponse = await api.post(
          `/v1/${practiseid}/patient/${data.patientid}/orders/create`,
          {
            department_id: userConfig?.config?.departmentid,
            patient_name: `${data.firstname || ""} ${
              data.lastname || ""
            }`.trim(),
            tov: tovValue, // purpose
            lov: data.lov,
            diagnosis: "",
            ordertype: "VISIT", // tabs
            ordername: tovValue, // buttons
            schedule: selectedCard, // t/f-schedule
            // provider: data.linked_provider,
            provider: `${userConfig?.firstname || ""} ${userConfig?.lastname || ""}`, 
            status: "CREATED",
            confirm_status: "E", // C/E
            orderdate:dayjs(dt).isValid()
  ? dayjs(dt).format("YYYY-MM-DD")
  : dayjs().format("YYYY-MM-DD"),
            encounterid: 0,
          }
        );
      }



      if (
        tov2Value !== getorder?.lovtov[0]?.tov2 ||
        lov2Value !== getorder?.lovtov[0]?.lov2
      ) {
        // only update if tov2Value exists
        tov2Value &&
          (await api.put(
            `/v1/${practiseid}/orders/update/patient/${data.patientid}/secondtovtask`,
            {
              task: "VISIT",
              orderdate:
                dt && dt.includes(" ") && !isNaN(Date.parse(dt.split(" ")[0]))
                  ? dt.split(" ")[0]
                  : new Date().toISOString().split("T")[0],
              lov2: lov2Value,
              tov2: tov2Value,
            }
          ));
      } else {
        // both values are same, do nothing
        console.log("No update needed, values unchanged.");
      }   
      const response = await api.post(
        `/v1/${practiseid}/patient/${data.patientid}/orders/confirm`,
        {
          patient_name: `${data.firstname || ""} ${data.lastname || ""}`.trim(),
          createdby: userConfig?.username || "",
          // "orderdate": data.created_at?new Date(data.created_at).toISOString().split('T')[0]: "Invalid date",
          orderdate:dayjs(dt).isValid()
  ? dayjs(dt).format("YYYY-MM-DD")
  : dayjs().format("YYYY-MM-DD"),
          tov: tovValue,
          lov: lovValue,
          diagnosis: icd10Array,
          appointmentid: data.appointmentid,
          token_no: 0,
          confirm_status: "E",
          update_status: "C",
        }
      );

      if (response.status === 200) {
       if(!block){
          setAlertMessage(response.message);
        setSeverity("success");
        setOpen(true);
        }
        setTimeout(() => {
          if (appointmentId) {
             eventBus.emit("fetchSummary")
            setShowOrders(false);
          } else {
            if( filter!=='all'){
      navigate('/landing', {
    state: { fromPatientId: data.patientid }
  })
            }else{
           navigate('/landing')   
            }
    
          }
        }, 2000);
      } else {
        setAlertMessage(response.message);
        setSeverity("info");
        setOpen(true);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
  setOrdersref(false)
   setShowUnsavedModal(false)
    }
  };
     //      const selectedsuggestions = await api.post(
      //   `/v1/${practiseid}/orders/patient/${data.patientid}/get-orders`,
      //   {
      //     appointmentid: data.appointmentid,
      //     // "orderdate": data.created_at ? new Date(data.created_at).toISOString().split('T')[0] : "Invalid date"
      //     orderdate:
      //       dt && dt.includes(" ") && !isNaN(Date.parse(dt.split(" ")[0]))
      //         ? dt.split(" ")[0]
      //         : new Date().toISOString().split("T")[0],
      //   }
      // );
  const handleexit=async ()=>{
    setLoading(true)
    try {
   console.log('came')
    
        if(latestorders?.length==0){
          if(ordersref){
             setOrdersref(false)
                eventBus.emit("fetchSummary")
            setShowOrders(false);
            return
          }
        //  handleSave(true)
         // return
        }
console.log(firstOrders,'firstorder',latestorders,'latest')
if(firstOrders.length!==latestorders?.length){
setShowUnsavedModal(true)
}else{
  if(ordersref){
     setOrdersref(false)
        eventBus.emit("fetchSummary")
            setShowOrders(false);
  return
  }
if(isOrdersRoute){
    if( filter!=='all'){
      navigate('/landing', {
    state: { fromPatientId: data.patientid }
  })
            }else{
           navigate('/landing')   
            }
}else{

    handleSave(true)
}
  console.log('calling,save')

}

    } catch (error) {
      console.log(error)
    }finally{
      setLoading(false)
  setOrders([])
  setOrdersref(false)
    }
  }


useEffect(()=>{
  if (isOrdersRoute) return;
  console.log('triggered')
if(ordersref){
handleexit()
}
},[ordersref,isOrdersRoute])

  return (
    <>
      {isLoading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
        >
          <CircularProgress />
        </Box>
      ) : (
        // Render the UI once loading is complete
        <OrdersLayout tab={tab} setTab={setTab}   data={{
    ...(appointmentData || {}),
    dob: searchcard?.dob || "",
  }}>
                                {tab !== 3 && (
              <div className="flex justify-end items-center mr-6 gap-2">
                <button
                  className="flex items-center justify-center font-inter font-medium rounded-lg text-xs border-[1px] border-[#0000001A] gap-1 text-[#0A0A0A] bg-[#FFFFFF] px-2.5 py-1"
                  onClick={() => {
                    handleClose();
                  }}
                >
                  {/* {crossIcon} */}
                  Clear All
                </button>
     <button
  onClick={handleSave}
  className="group flex items-center justify-center font-inter font-medium rounded-lg text-xs 
             border-[1px] border-[#0000001A] gap-1 text-[#0A0A0A] bg-[#FFFFFF] px-2.5 py-1
             hover:bg-[#1D2951] hover:text-white transition-colors duration-200"
>
  <SaveIconwithprop />
  Save
</button>

{!showOrders && (
  <div
    className="fixed top-[12.8%] right-4 z-50 cursor-pointer"
    onClick={handleexit}
  >
    <div className="bg-[#e17954] w-6 h-6 rounded-full flex items-center justify-center">
      <FontAwesomeIcon
        icon={faTimes}
        className="text-white text-base"
      />
    </div>
  </div>
)}

              </div>
            )}
          <div
            className={`w-full lg:flex px-3 pb-3  justify-center  items-center`}
          >
            <style>
              {`
                .nav-item {
                  transition: background-color 0.3s ease, color 0.3s ease;
                  background-color: transparent;
                  color: #4B5563; /* Default text color (text-gray-900) */
                }

                .nav-item:hover {
                  background-color: #50869A; /* Hover background color */
                  color: white; /* Text color turns white on hover */
                  
                }

                .nav-item.active {
                  background-color: #50869A; /* Active background color */
                  color: white;
                }

                .nav-item-icon img {
                  transition: filter 0.3s ease;
            
                }

             .nav-item:hover .nav-item-icon img,
    .nav-item.active .nav-item-icon img {
      filter: brightness(0) invert(1); /* Makes the image white on hover or active */
    }
              `}
            </style>
            <div />
            <div className="flex items-center gap-2">
              <List className="flex gap-4">
                {navItems.map((item, index) => (
                  <React.Fragment key={index}>
                    {item.divider ? (
                      <div className="my-1">
                        <hr className="border-gray-300" />
                      </div>
                    ) : (
                      <div
                        className={`px-2 gap-2 py-2 text-[13px] font-Font1 rounded-full text-center flex items-center cursor-pointer whitespace-nowrap nav-item ${
                          tab === item.id ? "active" : "shadow-md"
                        }`}
                        onClick={() => item.onClick(item.id)}
                      >
                        <div className="nav-item-icon ">{item.icon}</div>
                        {item.label}
                      </div>
                    )}
                  </React.Fragment>
                ))}
              </List>
              {/* {tab === 3 ? (
                <div>
                  <CloseIcon
                    className="cursor-pointer"
                    onClick={() => {
                      if (appointmentId) {
                        setShowOrders(false);
                      } else {
                        navigate("/landing");
                      }
                    }}
                  />
                </div>
              ) : (
                <></>
              )} */}
            </div>

          </div>


          <div className="w-full flex  flex-column  items-center">
            {tab !== 3 && (
              <div className="relative flex items-center w-[85%] mb-2 mr-8">
                {/* Left-aligned search icon */}
                {/* <FontAwesomeIcon
         icon={faSearch}
         className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
      /> */}

                {/* Search input field with reduced height */}
                <input
                  type="text"
                  value={universalSearch}
                  placeholder="Search"
                  onChange={(e) => {
                    handleuniversalSearch(e);
                  }}
                  className="rounded-full border w-full border-[#E4E4E7] pl-4 pr-4 py-1 text-base outline-none"
                />
              </div>
            )}
          </div>
          {/* {(tovValue.includes('New Patient') || tovValue.includes('Follow up') || tovValue.includes('Consultation')) ? (
    <div className="w-full flex justify-end items-center space-x-4 ">
    <div className="text-xs font-poppins tracking-tight font-thin">Level of Visit</div>
    <Slider
      value={lovValue}
      onChange={(e) => handleChange(e.target.value)}
      aria-labelledby="continuous-slider"
      min={0}
      max={5}
      step={1}
      sx={{
        width: 200, // Adjust width as needed
        height: 4, // Make it thin
      }}
    />
    <div className="ml-2">{lovValue}</div>
     </div>
       ) : (tovValue.includes('Wellness Commercial') || tovValue.includes('Wellness Medicare')) ? (
       <div className="w-full flex justify-end items-center space-x-4">
        <div className="text-xs font-poppins tracking-tight font-thin">Level of Visit</div>
        <select
         value={lovValue}
         onChange={(e) => handleChange(e.target.value)}
        className="w-48 h-8 px-2 text-xs font-poppins font-thin tracking-tight border rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
        >
      <option value="1">First</option>
      <option value="2">Subsequent</option>
    </select>
  </div>
) : null} */}

          <div className="w-full flex-1 overflow-y-auto">
            <Backdrop
              sx={{
                color: "secondary.main", // Sets the CircularProgress color to secondary
                backgroundColor: "rgba(255, 255, 255, 0.5)", // Semi-transparent white background
                zIndex: (theme) => theme.zIndex.drawer + 1,
              }}
              open={loading}
            ></Backdrop>
            <ToastMessage
              message={alertmessage}
              severity={severity}
              open={open}
              handleClose={handlealert}
            />
            {(() => {
              switch (tab) {
                case 0:
                  return (
                    <LabsTab
                      data={{
    ...(appointmentData || {}),
    dob: searchcard?.dob || "",
  }}
                      setShowOrders={setShowOrders}
                      appointmentId={appointmentId}
                      startDate={dt}
                      suggestionData={suggestionData}
                      fetchsuggestions={fetchsuggestions}
                      getordersData={getordersData}
                      selectedSuggestionList={selectedSuggestionList}
                      referals={referals}
                      SetSelectedCard={SetSelectedCard}
                      selectedCard={selectedCard}
                    />
                  );
                case 1:
                  return (
                    <Proceduretab
                     data={{
    ...(appointmentData || {}),
    dob: searchcard?.dob || "",
  }}
                      setShowOrders={setShowOrders}
                      appointmentId={appointmentId}
                      startDate={startDate}
                       suggestionData={suggestionData}
                      fetchsuggestions={fetchsuggestions}
                      getordersData={getordersData}
                      selectedSuggestionList={selectedSuggestionList}
                      referals={referals}
                      SetSelectedCard={SetSelectedCard}
                      selectedCard={selectedCard}
                    />
                  );
                case 2:
                  return (
                    <Injectionstab
                      data={appointmentData}
                      setShowOrders={setShowOrders}
                      appointmentId={appointmentId}
                      startDate={startDate}
                       suggestionData={suggestionData}
                      fetchsuggestions={fetchsuggestions}
                      getordersData={getordersData}
                      selectedSuggestionList={selectedSuggestionList}
                      referals={referals}
                      SetSelectedCard={SetSelectedCard}
                      selectedCard={selectedCard}
                    />
                  );
                case 3:
                  return (
                    <Refillstab
                      data={appointmentData}
                      setShowOrders={setShowOrders}
                      appointmentId={appointmentId}
                      startDate={startDate}
                    />
                  );
                case 4:
                  return (
                    <ScheduleTab
                      data={appointmentData}
                      setShowOrders={setShowOrders}
                      appointmentId={appointmentId}
                      startDate={startDate}
                       suggestionData={suggestionData}
                      fetchsuggestions={fetchsuggestions}
                      getordersData={getordersData}
                      selectedSuggestionList={selectedSuggestionList}
                      referals={referals}
                      SetSelectedCard={SetSelectedCard}
                      selectedCard={selectedCard}
                    />
                  );
                case 5:
                  return (
                    <ReferalsTab
                      data={appointmentData}
                      setShowOrders={setShowOrders}
                      appointmentId={appointmentId}
                      startDate={startDate}
                       suggestionData={suggestionData}
                      fetchsuggestions={fetchsuggestions}
                      getordersData={getordersData}
                      selectedSuggestionList={selectedSuggestionList}
                      referals={referals}
                      SetSelectedCard={SetSelectedCard}
                      selectedCard={selectedCard}
                    />
                  );
                case 6:
                  return (
                    <MedicalRecordsTab
                      data={appointmentData}
                      setShowOrders={setShowOrders}
                      appointmentId={appointmentId}
                      startDate={startDate}
                       suggestionData={suggestionData}
                      fetchsuggestions={fetchsuggestions}
                      getordersData={getordersData}
                      selectedSuggestionList={selectedSuggestionList}
                      referals={referals}
                      SetSelectedCard={SetSelectedCard}
                      selectedCard={selectedCard}
                    />
                  );
                  case 7:
                  return (
                    <VitaminTab
                      data={appointmentData}
                      setShowOrders={setShowOrders}
                      appointmentId={appointmentId}
                      startDate={startDate}
                       suggestionData={suggestionData}
                      fetchsuggestions={fetchsuggestions}
                      getordersData={getordersData}
                      selectedSuggestionList={selectedSuggestionList}
                      referals={referals}
                      SetSelectedCard={SetSelectedCard}
                      selectedCard={selectedCard}
                    />
                  );
                default:
                  return null;
              }
            })()}
          </div>

          <UnsavedChangesModal
  open={showUnsavedModal}
title={'Do you want to save before exiting ?'}
  confirmText="Save"
  cancelText="Cancel"
  onCancel={() => {
    handleClose()
    setShowUnsavedModal(false)}}
  onConfirm={() => {
  handleSave(true)
  setOrdersref(false)
  }}
/>
        </OrdersLayout>
      )}
    </>
  );
};

export default Orders;
